import { StripeWallet } from '../../../StripeWallet';
import type { SavedPaymentMethodOption } from '../../shared/types';

type Props = {
	selectedPaymentMethod: SavedPaymentMethodOption | null;
};

export const StripeWalletWrapper: React.FC<Props> = ({ selectedPaymentMethod }) => {
	if (selectedPaymentMethod !== 'applePay' && selectedPaymentMethod !== 'googlePay') {
		return null;
	}
	return <StripeWallet />;
};
